import { UserPermissions } from '@centecomm/portal-service';
import { User as UserIcon } from 'Icons';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';
import { FeatureConfiguration } from '../../../../Core/Types/FeatureConfiguration';

const LazyOwnerOperatorUserAdministrationPage = React.lazy(() => import('./Pages/OwnerOperatorUserAdministrationPage'));
const LazyTenantUserAdministrationPage = React.lazy(() => import('./Pages/TenantUserAdministrationPage'));

const userConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:company.users.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.company.users.title',
            url: '/users-settings',
            Icon: UserIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyOwnerOperatorUserAdministrationPage />
                </React.Suspense>
            ),
            tenantRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyTenantUserAdministrationPage />
                </React.Suspense>
            ),
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ViewUsers],
    },
    disableFeature: [],
};

export default userConfiguration;
